import React, { useState } from "react";
import { Icon } from "@vds/icons";
import { Modal, ModalBody, ModalTitle } from "@vds/modals";
import { Text } from '@vds/core';
import styled from "styled-components";
import { stripHTML } from "../../../utils/commonUtils";
import { useMediaQuery } from "react-responsive";
import { TextLink } from "@vds/buttons";

const PromoBannerVDS3 = ({
  bgColor,
  bodySize = "small",
  color,
  icon,
  promoData,
  showClose,
  tooltipIconSize = "small",
  isByod = false,
  isPromoHeaderHtml = false,
  children,
  detailsLink = ""
}) => {
  const [isVisible, setIsVisible] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const textColor = color || "#ffffff";
  const isMobile = useMediaQuery({
    query: "(max-width: 545px)",
  });

  const isTabletWidth = useMediaQuery({
    minWidth: 545 , maxWidth: 1023,
  });

  const smallerDevice = useMediaQuery({
    query: "(max-width:360px)",
  });


  if (isVisible && promoData?.heading) {
    return (
      <>
        {/* VBGHSA-14260: in case of gray background, open modal on click of gray banner itself */}
        <BannerContainer
          bgColor={bgColor}
          cursorPointer={!!promoData?.tooltipText}
          onClick={() =>
            !!bgColor && promoData?.tooltipText && setShowModal(true)
          }
          smallerDevice={smallerDevice}
          style={{marginTop:isMobile ? " -0.5rem" : isTabletWidth ?  "-1rem" : "-1rem"}}
        >
          {!!icon && <Icon name={icon} color={color || "#ffffff"} />}
          <TextContainer>
            <Text kind="body" size="small" color={textColor} bold>
              {isPromoHeaderHtml ? (
                <PromoBlackBannerText data-track={promoData?.heading} style={{display:"flex",justifyContent:"flex-end"}}>
                  {window.mbtGlobal.reactUibasePath === "/mbt/prospect/" ? (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: promoData?.headingQA?.replaceAll("&nbsp;", " "),
                      }}
                    ></div>
                  ) : (
                    <div 
                      dangerouslySetInnerHTML={{
                        __html: promoData?.heading?.replaceAll("&nbsp;", " "),
                      }}
                    ><span onClick={() =>
                        !!bgColor && promoData?.tooltipText && setShowModal(true)
                      }>
                {promoData?.showTooltip && promoData?.tooltipText && (
                  <Icon
                    name="info"
                    color={color || "#ffffff"}
                    size={tooltipIconSize}
                    
                  />
                )}
              </span></div>
                  )}
                  <span style={{marginRight:"-1rem"}}  onClick={() =>
                        !!bgColor && promoData?.tooltipText && setShowModal(true)
                      }>
                {promoData?.showTooltip && promoData?.tooltipText && (
                  
                  <Icon 
                    name="info"
                    color={color || "#ffffff"}
                    size={tooltipIconSize}
                    
                  />
                )}
              </span>
                </PromoBlackBannerText>
              ) : (
                  <PromoBlackBannerText>{stripHTML(promoData?.heading)?.replaceAll("&nbsp;", " ")}
                    {!(detailsLink?.length) ? <span style={{paddingLeft: "5px"}}>
                      {promoData?.showTooltip && promoData?.tooltipText && (
                        <Icon
                          name="info"
                          color={color || "#ffffff"}
                          size={tooltipIconSize}
                        />
                      )}
                    </span> :
                    <span style={{ position: "relative", paddingLeft: "5px" }}>
                      { promoData?.showTooltip && promoData?.tooltipText &&  (
                        <StyledTextLink
                          size="small"
                          // onClick={() => setShowModal(true)}
                        >
                          {detailsLink}
                        </StyledTextLink>
                      )}
                    </span>}
                  </PromoBlackBannerText>
              )}
            </Text>
          </TextContainer>
          {showClose && (
            <CloseIconWrapper onClick={() => setIsVisible(false)}>
              <Icon
                name="close"
                color={color || "#ffffff"}
                size={tooltipIconSize}
              />
            </CloseIconWrapper>
          )}
        </BannerContainer>
        {showModal && (
          <Modal
            opened={promoData?.tooltipText && showModal}
            onOpenedChange={setShowModal}
            data-track="Close"
            disableFocusLock= {true}
          >
            {isByod && promoData?.heading_1 && !promoData?.tooltipText.includes(".html") ? (
              <ModalTitle>
                <Text kind="title" size={!isMobile ? "medium" : "large"} bold>
                  {promoData?.heading_1 || ""}
                </Text>
              </ModalTitle>
            ) : (
              <div />
            )}

            <ModalText>
              <ModalBody>
                <ModalContent isByod={isByod}>
                   {promoData?.tooltipText.includes(".html") ? <iframe
                    style={{border:"none", backgroundColor:"white"}}
                    height={isMobile?"550px":"674px"}
                    width={isMobile?"100%":"560px"}
                    src={promoData?.tooltipText}
                  ></iframe> :  <span dangerouslySetInnerHTML={{ __html: promoData?.tooltipText,}}/>}
                </ModalContent>
              </ModalBody>
            </ModalText>
          </Modal>
        )}
      </>
    );
  } else return <></>;
};

const ModalText = styled.div`
[data-testid="modal-body"]{
  padding : 0;
}
@media only screen and (min-width: 320px) and (max-width: 767px) {
  [data-testid="modal-body"]{
    padding : 1rem;
  }
}
  }
`;

const BannerContainer = styled.div`
  border-radius: 8px;
  padding: 0.625rem 1rem;
  background-color: ${({ bgColor }) => (bgColor ? bgColor : "#333333")};
  margin-top:${({smallerDevice})=>(smallerDevice ? "-2.5rem":"")};
  display: flex;
  gap: 0.75rem;
  p {
    display: flex;
  }
  span {
    position: absolute;
  }
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    p {
      font-size: 12px;
      line-height: 16px;
      font-weight: 400;
      display: block;
    }
    span {
      position: relative;
      top: 5px;
    }
  }

  @media only screen and (max-width: 525px) {
    span {
      top: 0px;
      right: -2px;

      & > svg {
        position: absolute;
      }
    }
  }
`;

const TextContainer = styled.div`
  display: flex;
  gap: 0.25rem;
  p {
    font-weight: 700;
  }
`;

const CloseIconWrapper = styled.div`
  margin-left: auto;
  cursor: pointer;
`;

const ModalContent = styled.div``;


const PromoBlackBannerText = styled.div`
  a {color:#fff;}
  margin-right:10px;
  span {
    position: relative;
    font-weight: 500;
    & > a {
      > span {
        position: relative ;
        
      }
    }
  }
`;

const StyledTextLink = styled(TextLink)`
color: #ffffff;
font-weight: 600 !important;
:hover{
color: #ffffff;
}
&:hover{
color: #ffffff;
}
`

export default PromoBannerVDS3;
